export type ActionRecaptchaType = "SIGNIN" | "SIGNUP" | "RESET_PASSWORD" | "FORGOT_PASSWORD";
let siteKey = "";

export const configureRecaptcha = (key: string) => {
  siteKey = key;
};

export const createRecaptchaScriptElement = (key: string) => {
  const script = document.createElement("script");
  script.src = `https://www.google.com/recaptcha/enterprise.js?render=${key}`;
  script.async = true;
  script.defer = true;

  return script;
};

export const getRecaptchaToken = async (action: ActionRecaptchaType) => {
  if (!siteKey) {
    throw new Error("Recaptcha site key is not configured");
  }

  const token = await window.grecaptcha?.enterprise.execute(siteKey, {
    action: action,
  });

  if (!token) {
    throw new Error("Failed to get recaptcha token");
  }

  return token;
};
